class TradeAccountBanner {
  constructor() {
    this.init();
  }

  init() {
    const buttons = document.querySelectorAll('.trade-account__button');

    if (buttons.length === 0) return;

    buttons.forEach(button => {
      const originalHref = button.getAttribute('href');

      button.addEventListener('click', (e) => {
        if (!originalHref || originalHref.startsWith('#') || originalHref === '') {
          e.preventDefault();
          this.scrollToDiscountTiers();
        } else {
          if (button.getAttribute('data-scroll-to-tiers') === 'true') {
            e.preventDefault();
            this.scrollToDiscountTiers();
          }
        }
      });
    });
  }

  scrollToDiscountTiers() {
    const discountTiersSection = document.querySelector('[id^="ud-discount-tiers-"]');

    if (!discountTiersSection) {
      console.warn('Discount tiers section not found');
      return;
    }

    const header = document.querySelector('header, .header');
    let offset = 0;

    if (header && header instanceof HTMLElement) {
      const headerHeight = header.offsetHeight;
      offset = headerHeight + 20;
    }

    const targetPosition = discountTiersSection.getBoundingClientRect().top + window.pageYOffset - offset;

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth'
    });
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new TradeAccountBanner();
  });
} else {
  new TradeAccountBanner();
}
